export function isMobile() {
    const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return width < 768;
}

export function isTablet() {
    const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return width >= 768 && width <= 1199;
}

export function isDesktop() {
    const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return width >= 1200;
}

export function getDeviceWidth() {
    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
}

export function getDevicePixelRatio() {
    return window.devicePixelRatio;
}

export function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export function rgb2hex(rgb) {
    const color = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return (color && color.length === 4)
        ? (`0${parseInt(color[1], 10).toString(16)}`).slice(-2)
        + (`0${parseInt(color[2], 10).toString(16)}`).slice(-2)
        + (`0${parseInt(color[3], 10).toString(16)}`).slice(-2) : '';
}

/** @description Strips query string and preceding tilda from url
 */
export function stripUrl(url) {
    const regex = /.*(?=\?)/;
    let urlNoParam = url;
    if (regex.test(url)) {
        urlNoParam = regex.exec(url)[0]; // eslint-disable-line prefer-destructuring
    }
    if (urlNoParam.charAt(0) === '~') {
        urlNoParam = urlNoParam.subst(1);
    }
    return urlNoParam;
}

export function GetColumnClasses(element){
    var classes = '';
    element.classList.forEach(function(value) {
        if(value.startsWith('col-')){
            classes += ` ${value}`;
        }
    });
    return classes;
}

export function stringToBool(string){
    const dictionary = {
        True: true, False: false, true: true, false: false,
    };
    return dictionary[string] || false;
}

export class Globals {
    constructor() {
        const width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        this.isMobile = width < 768;
    }

    set IsMobile(val) {
        this.isMobile = val;
    }

    get IsMobile() {
        return this.isMobile;
    }
}

window.Globals = Globals;
export default Globals;
